// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "9590321b4895b61b","396": "0ce7c5ef6bc8c992","460": "420db556cbde48c6","917": "6d7da02976819a56","985": "e6c04040d644d1d5",}[chunkId] + ".chunk.js"
}